import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import { IBoardInfoData } from "@/domain/entities/board";
import LineTypeChip from "../shared/chip/LineTypeChip.vue";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";


const __default__ = {
  name: "BoardHistoryRowInfo",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardInfo: {
    type: Object as PropType<IBoardInfoData>,
    required: true,
  },
},
  emits: ["onClickBusStopLocation"],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



dayjs.locale("ko");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Seoul");

const busInfoText = computed(() => {
  if (!props.boardInfo) return "-";
  const { carNo, vendorName } = props.boardInfo;

  return `${carNo ?? "-"}${vendorName ? `(${vendorName})` : ""}`;
});

const __returned__ = { props, busInfoText, LineTypeChip, get useGetLineRouteName() { return useGetLineRouteName }, get dayjs() { return dayjs } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})